import React from 'react'
import styled from 'styled-components'
import sectionBg from '../static/images/backgrounds/down_pic.jpg'
import { colors, media } from '../styles/vars'
import ArticleLink from '../components/ArticleLink'

const Container = styled.div`
background-repeat:no-repeat;
background-size:cover;
background-position:center top;
background-image:url(${sectionBg});
background-color:gray;
padding:343px 0 100px;

${
    media.desktop`
    padding:200px 0 400px;
    `
    }
`
const ArticleContainer = styled.div`
padding:15px;
background-color:rgba(0, 0, 0, .8);
width:80%;
margin:0 auto;
text-align:center;

${
    media.desktop`
     text-align:right;
     width:480px;
     margin:0 100px 0 0;
     >:last-child{

     }
    `
    }
`
const ArticleTitle = styled.h2`
font-weight:700;
font-size:3.3rem;
color:${colors.yellow};

${
    media.desktop`
    font-size:4rem;
    line-height:.9;
    `
    }
`
const ArticleSubtitle = styled.h3`
font-size:2.2rem;
color:${colors.white};
margin:5px 0;
${
    media.desktop`
    font-size:2.6rem;
    `
    }
`
const LinkContainer = styled.div`
margin-top:10px;
${
    media.desktop`
    margin-top:20px;
    text-align:left;
    `
    }
`
const ArticleSection = () => {
    return (
        <Container>
            <ArticleContainer>
                <ArticleTitle>
                    נתנו גז
                </ArticleTitle>
                <ArticleSubtitle>
                    הספורט המוטורי בישראל ידע לא מעט קשיים - אבל גם כמה כוכבים מקומיים שזכו להישגים בינלאומיים במרוצים החשובים בעולם. זהו סיפורם
                </ArticleSubtitle>
                <LinkContainer>
                    <ArticleLink articleId="5099762" />
                </LinkContainer>
            </ArticleContainer>
        </Container>
    )
}

export default ArticleSection;


// WEBPACK FOOTER //
// ./src/containers/ArticleSection.jsx